type GetParamsFunc = () => Record<string, unknown>;

export let getDefaultAnalyticsParams: GetParamsFunc = () => ({ ...window?.globalVars?.analyticsParams });

export const initGetterAnalyticsParams = (func: GetParamsFunc) => {
    getDefaultAnalyticsParams = func;
};
